import { Str } from '@livecontrol/core-utils';
import { EventValidator } from './types';

export const validateMobileEventLocation = (
  newEventInfo: EventValidator.EventInfo
): EventValidator.Errors => {
  const errors: EventValidator.Errors = {};
  const location = Str.normalize(newEventInfo.mobileKitData?.location);

  if (!location) {
    errors.mobileKitData ??= {};
    errors.mobileKitData.location = EventValidator.ErrorMessages.MOBILE_LOCATION_MISSING;
  }

  return errors;
};
